import { ButtonHTMLAttributes, forwardRef } from 'react';
import { Loader2 } from 'lucide-react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ 
  className = '', 
  variant = 'primary', 
  size = 'md', 
  isLoading, 
  children, 
  disabled, 
  ...props 
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all focus:outline-none';
  
  const variants = {
    primary: 'bg-gradient-cta text-on-primary-container rounded shadow-sm hover:shadow-ambient',
    secondary: 'bg-transparent border border-outline-variant/20 text-on-surface hover:bg-surface-bright',
    tertiary: 'bg-transparent text-primary hover:text-primary-fixed-dim',
    danger: 'bg-error-container text-on-error-container hover:bg-error-container/80'
  };

  const sizes = {
    sm: 'text-sm px-3 py-1.5 rounded',
    md: 'text-sm px-4 py-2 rounded-md',
    lg: 'text-base px-6 py-3 rounded-md'
  };

  return (
    <button
      ref={ref}
      // Gancho do visual novo (visual-google.css): pílula e primário chapado.
      data-btn={variant}
      disabled={isLoading || disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      {...props}
    >
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
});

Button.displayName = 'Button';
